import styled from "styled-components";

export const AboutMeContent = styled.section`
    color: var(--dark--primary--text);
    height: max-content;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin: 5rem 0;

    padding-top: 4rem;

    span{
        color: var(--dark--green--50);
    }

    h1{
        font-size: 3rem;
        padding-bottom: 3rem;
        span{
            color: var(--dark--green--50);
        }
    }

    div{
        text-align: justify;         
        padding: 0 15px; 
    }
 


`